import { memo } from 'react'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import SearchIcon from '../../assets/icons/SearchIcon'
import ClearIcon from '../../assets/icons/ClearIcon'

type Props = {
    value: string
    onChange: (value: string) => void
    placeholder: string
    autoFocus?: boolean
}

/** Compact search input matching the orders/positions sidebar search. */
const SupportSearchField = ({ value, onChange, placeholder, autoFocus }: Props) => (
    <TextField
        fullWidth
        size="small"
        autoFocus={autoFocus}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        inputProps={{ 'aria-label': placeholder }}
        InputProps={{
            sx: { height: 32, pl: 1, fontSize: 13 },
            startAdornment: (
                <InputAdornment position="start" sx={{ mr: 0.5 }}>
                    <SearchIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                </InputAdornment>
            ),
            endAdornment: value ? (
                <InputAdornment position="end">
                    <IconButton size="small" aria-label="Clear search" onClick={() => onChange('')} sx={{ color: 'text.secondary' }}>
                        <ClearIcon sx={{ fontSize: 14 }} />
                    </IconButton>
                </InputAdornment>
            ) : null
        }}
    />
)

export default memo(SupportSearchField)
